import { render } from "./RefundPolicy.vue?vue&type=template&id=a8225ca2"
import script from "./RefundPolicy.vue?vue&type=script&lang=js"
export * from "./RefundPolicy.vue?vue&type=script&lang=js"

import "./RefundPolicy.vue?vue&type=style&index=0&id=a8225ca2&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__